import axios from "axios";
import strings from "./strings";

// for date
import NibjarNepaliDate from "./nibjar-nepali-date/nibjar-nepali-converter";
import { adToBs } from "@sbmdkl/nepali-date-converter";
import moment from "moment";

// components
import InvoiceTemplate from "../components/invoice-template/invoice-template.component";

export function isEmptyObject(obj) {
	for (var key in obj) {
		if (obj.hasOwnProperty(key)) return false;
	}
	return true;
}

// customer_tag is stored as a "#"-delimited string, e.g. "#vip#wholesale"
// (see customer-profile.component.tsx) — shared parser for anywhere that
// needs to display it as a tag list.
export function convertTagToArray(string) {
	return string?.split("#").filter(Boolean) ?? [];
}

export async function sessionInfo() {
	try {
		const response = await axios.get(`${strings.url}user/current`, {
			headers: {
				"Content-Type": "application/json",
			},
			withCredentials: true,
		});

		const { result, success } = response.data;

		if (success && result) {
			// Attach token manually if you want (optional)
			return { ...result };
		} else {
			return 0;
		}
	} catch (error) {
		console.error(
			"Session check failed:",
			error?.response?.data || error.message
		);
		return 0;
	}
}

export function nepaliDateMMMM(date) {
	return (
		date?.split("-")[2] +
		" " +
		strings.nepaliMonth[parseInt(date?.split("-")[1]) - 1].value +
		" " +
		date?.split("-")[0]
	);
}

export function fromAdToBs(date, nepFormat = "YYYY-MM-DD") {
	try {
		return new NibjarNepaliDate(new Date(date)).format(nepFormat);
	} catch (err) {
		// console.log(err, "--------")
		return "";
	}
}

export function fromBsToAd(date, engFormat = "YYYY-MM-DD") {
	try {
		let engDateObj = new NibjarNepaliDate(date).getAD();

		engDateObj = {
			year: engDateObj.year,
			month: engDateObj.month,
			day: engDateObj.date,
		};

		return moment(engDateObj).format(engFormat);
	} catch (err) {
		// console.log(err, "--------")
		return "";
	}
}

// BE stores nepali dates dot-separated ("2083.04.05" — see billing_system_BE
// helper/helper.js's getFiscalYear). NibjarNepaliDate's string constructor
// only recognizes "-"/"/" separators, so normalize before formatting.
export function formatBsDateString(bsDate, nepFormat = "DD MMMM, YYYY") {
	if (!bsDate) return "";
	try {
		return new NibjarNepaliDate(bsDate.replace(/\./g, "-")).format(nepFormat);
	} catch (err) {
		return "";
	}
}

// to get years for dropdown
export function getEnYear() {
	const currentYear = new Date().getFullYear();
	const years = [];

	for (let year = 2020; year <= currentYear; year++) {
		years.push({ id: year, value: year });
	}

	return years;
}

export function getNepYear() {
	const currentYear = +adToBs(moment().format("YYYY-MM-DD")).split("-")[0];
	let year = 2078,
		yearArray = [],
		fiscalYear = 78;

	for (var i = 2078; i <= currentYear; i++) {
		fiscalYear++;
		yearArray.push(
			{ id: year, value: year },
			{
				id: year + "-04-01/" + (+year + 1 + "-03-31"),
				value: year + "/" + fiscalYear,
			}
		);

		year++;
	}

	return yearArray;
}

// Fiscal years as { id: "2080.081", value: "2080/081" } — id is the exact
// "XXXX.XXX" string the BE's fiscal_year column/validation expects, value is
// the readable range label shown in the dropdown.
export function getNepaliFiscalYears() {
	const currentYear = +adToBs(moment().format("YYYY-MM-DD")).split("-")[0];
	const years = [];

	for (let year = 2078; year <= currentYear; year++) {
		const nextYearSuffix = String((year + 1) % 1000).padStart(3, "0");
		years.push({
			id: `${year}.${nextYearSuffix}`,
			value: `${year}/${nextYearSuffix}`,
		});
	}

	return years;
}

// multi page invoice view
export function splitArray(arr, maxLength = 10, maxLastChunk = 4) {
	const slicedArrays = [];
	let currentIndex = 0;

	while (currentIndex < arr.length) {
		const remainingItems = arr.length - currentIndex;
		const chunkSize =
			remainingItems > maxLength ? maxLength : remainingItems;
		const chunk = arr.slice(currentIndex, currentIndex + chunkSize);
		slicedArrays.push(chunk);
		currentIndex += chunkSize;
	}

	// Ensure the last chunk has a maximum length of 6
	if (slicedArrays.length >= 1) {
		const lastChunk = slicedArrays.pop();
		if (lastChunk.length > maxLastChunk) {
			// Split the last chunk into 2 parts
			const part1 = lastChunk.slice(0, lastChunk.length - 1);
			const part2 = lastChunk.slice(lastChunk.length - 1);
			slicedArrays.push(part1, part2);
		} else {
			slicedArrays.push(lastChunk);
		}
	}

	return slicedArrays;
}

// return template component based on template ID store in DB
export function getSelectedTemplate(
	templateID,
	selectedBill,
	showBillFooter,
	page,
	fontStyle,
	isCreditNote = false,
	lastCount = 0

) {
	switch (templateID) {
		case 1:
			return (
				<InvoiceTemplate
					selectedBill={selectedBill}
					showBillFooter={showBillFooter}
					page={page}
					fontStyle={fontStyle}
					isCreditNote={isCreditNote}
					lastCount={lastCount}
				/>
			);
		default:
			return (
				<InvoiceTemplate
					selectedBill={selectedBill}
					showBillFooter={showBillFooter}
					page={page}
					fontStyle={fontStyle}
					isCreditNote={isCreditNote}
				/>
			);
	}
}

// Access based on user roles => returns true or false
// export async function roleAccess(model, action) {
// 	const currentUserRole = (await sessionInfo()).user_role;

// 	const roleAccessObject = {
// 		company: {
// 			edit: {
// 				owner: true,
// 				user: false,
// 			},
// 			view: {
// 				owner: true,
// 				user: true,
// 			}
// 		},
// 		employee: {
// 			add: {
// 				owner: true,
// 				user: false,
// 			},
// 			edit: {
// 				owner: true,
// 				user: false,
// 			},
// 		}
// 	}

// 	return roleAccessObject[model][action][currentUserRole];
// }

// Access based on user roles => returns true or false
export async function roleAccess(model) {
	const currentUserRole = (await sessionInfo()).user_role;

	const roleAccessObject = {
		company: {
			owner: {
				edit: true,
				view: true,
				viewExtApp: true,
				viewIdentification: true,
			},
			user: {
				edit: false,
				view: true,
				viewExtApp: false,
				viewIdentification: false,
			},
		},
		employee: {
			owner: {
				edit: true,
				view: true,
				delete: true,
			},
			user: {
				edit: false,
				view: true,
				delete: false,
			},
		},
	};

	return roleAccessObject[model][currentUserRole];
}

// return amount separated by commas for nepali currency format
export function rupeeConverter(amount = 0) {
	let rsAmt = parseFloat(amount);
	const rs = rsAmt.toLocaleString("en-IN", {
		maximumFractionDigits: 2,
		minimumFractionDigits: 2,
	});
	return rs;
}

// Function that returns nepali currency in words
// number should be fixed to atmost 2 decimal
export function converToWord(numberToConvert) {
	let number,
		no,
		point,
		hundred,
		digits_1,
		i,
		str,
		words,
		digits,
		divider,
		plural,
		counter,
		result,
		points,
		inWords;
	number = numberToConvert.toString().split(".");
	no = number[0];
	point = number[1];
	hundred = "";
	digits_1 = no.length;
	i = 0;
	str = [];
	words = {
		0: "",
		1: "One",
		2: "Two",
		3: "Three",
		4: "Four",
		5: "Five",
		6: "Six",
		7: "Seven",
		8: "Eight",
		9: "Nine",
		10: "Ten",
		11: "Eleven",
		12: "Twelve",
		13: "Thirteen",
		14: "Fourteen",
		15: "Fifteen",
		16: "Sixteen",
		17: "Seventeen",
		18: "Eighteen",
		19: "Nineteen",
		20: "Twenty",
		30: "Thirty",
		40: "Forty",
		50: "Fifty",
		60: "Sixty",
		70: "Seventy",
		80: "Eighty",
		90: "Ninety",
	};
	digits = ["", "Hundred", "Thousand", "Lakh", "Crore", "Arab", "Kharab"];
	while (i < digits_1) {
		divider = i === 2 ? 10 : 100;
		number = Math.floor(no % divider);
		no = Math.floor(no / divider);
		i += divider === 10 ? 1 : 2;
		if (number) {
			counter = str.length;
			plural = counter && number > 9 ? "s" : "";
			hundred = counter === 1 && str[0] ? "and " : "";
			str.push(
				number < 21
					? words[number] +
					" " +
					digits[counter] +
					plural +
					" " +
					hundred
					: words[Math.floor(number / 10) * 10] +
					" " +
					words[number % 10] +
					" " +
					digits[counter] +
					plural +
					" " +
					hundred
			);
		} else {
			str.push("");
		}
	}
	str = str.reverse();
	result = str.join("");
	points =
		point && point !== "00"
			? words[parseInt(point / 10)] + " " + words[(point = point % 10)]
			: "";
	inWords = points
		? result + "Rupees and " + points + " Paisa Only."
		: result + "Rupees Only.";
	inWords = inWords.replace(/\s+/g, " ");

	return inWords;
}
